module.exports = __webpack_public_path__ + "static/grammar-00b9a5f18cac99f801c3f57f1e803b8c.png";